import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { FullCalendarComponent } from '@fullcalendar/angular';
import esLocale from '@fullcalendar/core/locales/es';

import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-workout-calendar',
  templateUrl: './workout-calendar.component.html',
  styleUrls: ['./workout-calendar.component.scss'],
})
export class WorkoutCalendarComponent implements OnInit {
  @Input() routineGroupId!: number;
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

  modalShow: 'calendar' | 'workout' = 'calendar';

  calendarData: any;

  constructor(
    private routineService: RoutineService,
    private stateService: StateService
  ) {}

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay',
    },
    locale: esLocale,
    events: [],
    plugins: [dayGridPlugin],
    eventClick: this.handleEventClick.bind(this),
    dayCellDidMount: (info) => {
      const dayNumber = info.el.querySelector(
        '.fc-daygrid-day-number'
      ) as HTMLElement;
      if (dayNumber) {
        dayNumber.style.color = '#727578'; // Set the color of the day numbers to a brighter tone
      }
    },
    datesSet: (info) => {
      const dayHeaders = document.querySelectorAll(
        '.fc-col-header-cell-cushion'
      );
      dayHeaders.forEach((header) => {
        (header as HTMLElement).style.color = '#727578'; // Set the color of the day of the week to a brighter tone
      });
    },
  };

  ngOnInit(): void {
    this.setEventListener();
  }

  handleBackButtonClick() {
    this.modalShow = 'calendar';

    this.getRoutineModelGroupCalendar();
  }

  getRoutineModelGroupCalendar() {
    this.routineService
      .getRoutineGroupCalendar(this.routineGroupId)
      .subscribe((data: any) => {
        this.calendarData = data;
        if (!data) return;

        const events = data.map((item: any) => ({
          title: item.routineModelName,
          date: new Date(item.date).toISOString().split('T')[0], // Correctly parse the date
          color: '#FED534', // Set the color of the event to a brighter tone
          textColor: 'black', // Set the text color of the event to black
          extendedProps: {
            workoutId: item.workoutId, // Add workoutId to the event
          },
        }));

        this.calendarOptions.events = events;
        this.renderCalendar();
      });
  }

  setEventListener() {
    const modalElement = document.getElementById('workoutCalendarModal');
    modalElement!.addEventListener('shown.bs.modal', () => {
      this.getRoutineModelGroupCalendar();
      this.renderCalendar();
    });

    modalElement!.addEventListener('hidden.bs.modal', () => {
      this.modalShow = 'calendar';
    });
  }

  renderCalendar() {
    setTimeout(() => {
      this.calendarComponent.getApi().render();
    }, 100);
  }

  handleEventClick(info: any) {
    this.modalShow = 'workout';
    this.stateService.selectedWorkoutId = info.event.extendedProps.workoutId;
    this.onModalShowChange(this.modalShow);
    // You can add more logic here
  }

  onModalShowChange(modalShow: string): void {
    this.stateService.setModalShow(modalShow);
  }
}
